import type { ComponentType, SVGProps } from 'react';

import { ActivityIcon } from './icons/activity';
import { AnimalIcon } from './icons/animal';
import { FlagIcon } from './icons/flag';
import { FoodIcon } from './icons/food';
import { ObjectIcon } from './icons/object';
import { SmileIcon } from './icons/smile';
import { SymbolIcon } from './icons/symbol';
import { TravelIcon } from './icons/travel';

export type GroupName =
  | 'Smileys & People'
  | 'Animals & Nature'
  | 'Food & Drink'
  | 'Activity'
  | 'Travel & Places'
  | 'Objects'
  | 'Symbols'
  | 'Flags';
export const GROUPS: GroupName[] = [
  'Smileys & People',
  'Animals & Nature',
  'Food & Drink',
  'Activity',
  'Travel & Places',
  'Objects',
  'Symbols',
  'Flags',
];
export const GROUP_LABEL_MAP: Record<GroupName | 'Recent', string> = {
  Recent: '最近使用',
  'Smileys & People': '笑脸与人物',
  'Animals & Nature': '动物与自然',
  'Food & Drink': '食品与饮品',
  Activity: '运动与活动',
  'Travel & Places': '旅行与地点',
  Objects: '物品',
  Symbols: '符号',
  Flags: '旗帜',
};
export const GROUP_ICON_MAP: Record<
  GroupName,
  ComponentType<SVGProps<SVGSVGElement>>
> = {
  'Smileys & People': SmileIcon,
  'Animals & Nature': AnimalIcon,
  'Food & Drink': FoodIcon,
  Activity: ActivityIcon,
  'Travel & Places': TravelIcon,
  Objects: ObjectIcon,
  Symbols: SymbolIcon,
  Flags: FlagIcon,
};
